import axiosAuth from '../../axiosMain';

async function show(consumption_category_id) {
  let response = await axiosAuth.get('/total_data_consumption/' + consumption_category_id);
  return response.data;
}

export default {
  show,
};
